import * as cons from './constants';
import { action_ui_maker } from '../helpers/helpers';

export const setAppLanguage = option => (action_ui_maker({ cons: cons.APP_LANGUAGE, ...option }));
export const setDefaultSalesOrderData = option => (action_ui_maker({ cons: cons.SET_DEFAULT_SALES_ORDER_DATA, ...option }));
export const setDefaultServiceMemoData = option => (action_ui_maker({ cons: cons.SET_DEFAULT_SERVICE_MEMO_DATA, ...option }));
export const setDefaultShopOrderData = option => (action_ui_maker({ cons: cons.SET_DEFAULT_SHOP_ORDER_DATA, ...option }));
export const setStockCheckItemCode = option => (action_ui_maker({ cons: cons.SET_STOCK_CHECK_ITEM_CODE, ...option }));
export const resetError = option => (action_ui_maker({ cons: cons.RESET_ERROR, ...option }));
